module.exports = __webpack_public_path__ + "media/bowser-jr.36d17aa2.wav";